export default "__VITE_ASSET__mJOkYs2V__"